<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Map Manager - Add Map</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form enctype="multipart/form-data">
          <div class="form-group row">
            <label class="col-2">Name</label>
            <input type="text" class="form-control col-8" placeholder="Name of map" v-model="map.name"/>
          </div>
          <div class="input-group mb-3">
            <div class="custom-file">
              <input type="file" class="custom-file-input" accept=".png" @change="processFile($event)">
              <label class="custom-file-label">{{ map.image_name }}</label>
            </div>
          </div>
          <small class="form-text text-muted">Only PNG files are accepted. Recommended size is 960x740.</small>
          <br><br>
          <button type="button" class="btn btn-hub-primary" @click="addMap()">Save</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
      map: {
        name: '',
        image_name: '',
        image: ''
      }
    }
  },
  methods: {
    processFile (event) {
      this.map.image_name = event.target.files[0].name
      this.map.image = event.target.files[0]
    },
    addMap () {
      if (this.map.name !== '') {
        if (this.map.image !== '') {
          this.$store.dispatch('addMap', this.map)
        } else {
          alert('Please select an image for the new map.')
        }
      } else {
        alert('Please enter a name for the new map.')
      }
    }
  }
}
</script>
